import styled from 'styled-components'

export const IconWrapper = styled.span`
  display: none;
  align-items: center;
  cursor: pointer;
`

export const CustomOverlay = styled.div`
  font-size: 12px;
  line-height: 1.5;
  font-weight: 400;
  padding: 8px 4px;
  max-width: 260px;
  color: #f9fafb;
`
